import { render, staticRenderFns } from "./CouponsPerCategorey.vue?vue&type=template&id=7f153056&scoped=true&"
import script from "./CouponsPerCategorey.vue?vue&type=script&lang=js&"
export * from "./CouponsPerCategorey.vue?vue&type=script&lang=js&"
import style0 from "./CouponsPerCategorey.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CouponsPerCategorey.vue?vue&type=style&index=1&id=7f153056&scoped=true&lang=css&"
import style2 from "./CouponsPerCategorey.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f153056",
  null
  
)

export default component.exports